export const articleBodies: Record<string, string[]> = {
  'article-1': [
    '很多人第一次看完《姐姐的朋友》，都会有一种说不上来的失落感。它没有大起大落的情节，也没有一句把话说透的告白，可正是这种克制，让人物之间那点小心翼翼的喜欢显得格外真实。',
    '导演陈屿在大量镜头里选择了留白：一个停顿、一次欲言又止、一个没有按下的发送键。观众被迫自己去补全那些没被说出口的情绪，于是每个人心里都长出了属于自己的那个结局。',
    '在爱情片越来越依赖强冲突的当下，《姐姐的朋友》证明了一件事——把分寸感做好，比把情绪拉满更难，也更动人。这或许就是它能在众多同类作品中脱颖而出的原因。',
  ],
  'article-2': [
    '江辰不是那种会主动出击的男主角。相反，他礼貌、克制，甚至有一点疏离，可正是这份「不主动」，让他成为一个特别难得的存在。',
    '顾时安在塑造这个角色时，把大量的表演放在了台词之外。他习惯用视线的高度、身体的距离来传达人物的分寸——喜欢，但不越界；在乎，但懂得退让。',
    '在一个习惯把「占有」当作深情的语境里，江辰提供了一种更成熟的想象：真正的喜欢，有时候是让彼此都保持体面。这也是观众把他称为「白月光」的原因。',
  ],
  'article-3': [
    '从电影到剧集，《姐姐的朋友》系列完成了一次并不容易的续写。剧集版《重逢》没有简单复刻电影的成功公式，而是把视角拉得更宽。',
    '主创团队在访谈中提到，他们希望把「重逢」拍成一个关于成长的故事，而不仅仅是一段关系的延续。因此配角线被充分展开，每个人都有自己的困境与选择。',
    '这种取舍让剧集的节奏比电影更慢，却也让人物更立体。对于熟悉这个系列的观众来说，《重逢》更像是一种陪伴，而非一次冲击。',
  ],
  'article-4': [
    '今年的暑期档给人的最大感受，是类型片开始愿意认真讲故事了。无论是科幻爱情还是硬核冒险，创作者们都在尝试把更真诚的情感内核塞进类型的框架里。',
    '过去我们常看到「为类型而类型」的作品——特效堆满、情绪空洞。而这一批新片则相反，它们更愿意花时间在人物动机上做功夫。',
    '这种变化未必立刻带来票房奇迹，但却让类型片重新拥有了被反复讨论的价值。对一个健康的电影市场来说，这比一时的热度更重要。',
  ],
  'article-5': [
    '科幻和爱情看似是两个遥远的题材，但当它们相遇，往往能产生奇妙的化学反应。《星尘之约》的成功，正是这种结合的绝佳案例。',
    '它的关键从来不是特效有多炫，而是科幻设定为情感提供了一个足够极端、也足够纯粹的舞台。在跨越光年的距离面前，所有的犹豫都被放大，也都被照亮。',
    '当一部科幻片真正打动人的是爱情，当一部爱情片吸引人的是科幻，两者的边界其实已经不重要了。',
  ],
  'article-6': [
    '好剧不少，值得二刷的却不多。我们按题材整理了今年评分与口碑俱佳的十部剧集，希望能帮你把有限的追剧时间花在真正的好故事上。',
    '这份清单覆盖了悬疑、年代、都市与青春等类型，每一部都附上了看点提示与合适的观影状态——有的适合深夜独自观看，有的适合与家人一起分享。',
    '二刷的意义在于，第一次看故事，第二次看细节。真正扎实的作品，总能在重看时给出新的发现。',
  ],
  'article-7': [
    '《长夜将明》几乎不靠巧合推动剧情，这是它最难得的地方。每一条线索、每一次反转，都能在之前的细节里找到伏笔。',
    '剧本的节奏控制同样出色。它不是一味地制造悬念，而是懂得在紧张与舒缓之间切换，让观众有时间去怀疑、去推理、去被误导。',
    '当一部悬疑剧愿意尊重观众的智商，观众自然也愿意为它二刷三刷。这或许就是高分的真正来源。',
  ],
  'article-8': [
    '观众在屏幕上看到的，往往只是一个角色最后呈现出来的样子。但在那之前，是演员们大量看不见的功课。',
    '从方言训练到体态调整，从人物小传到生活细节的观察，一个角色的诞生远比想象中漫长。很多准备最终未必出现在成片里，却构成了表演的底色。',
    '这或许就是「实力派」三个字的分量——不是技巧的炫技，而是把准备工作做到足够扎实，让表演看起来毫不费力。',
  ],
  'article-9': [
    '林知夏的表演，很难用某一两个具体的动作去概括。她更像是在用一种整体的气息去包裹角色，让情绪从细节里慢慢渗出来。',
    '在《姐姐的朋友》里，她几乎没有大段的情绪爆发戏，却让观众准确地接收到了苏念每一次心动与失落。这种「藏在眼神里」的处理方式，需要极高的控制力。',
    '到了《追光者》，她又呈现出完全不同的质地。对角色的敬畏，或许正是她每一次都能带来惊喜的原因。',
  ],
};